import  { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../config.js"

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const EmployeTaskChart = () => {
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/EmployeJson`);
        
        setChartData(response.data.data);
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else if (!chartData.Sheet1 || chartData.Sheet1.length === 0) {
    
    return (
      <Container>
        <Typography variant="h6">No data available</Typography>
      </Container>
    );
  } else {
    const data = {
      labels: chartData.Sheet1.map((item) => item["YEAR"]),
      datasets: [
        {
          label: "Employee Task Quality",
          data: chartData.Sheet1.map((item) => item["__EMPTY"]),
          backgroundColor: [
            "#FF6384", // Bright pink
            "#36A2EB", // Bright blue
            "#FFCE56", // Bright yellow
            "#4BC0C0", // Bright teal
            "#9966FF", // Bright purple
            "#FF9F40", // Bright orange
            // Repeat colors if needed
          ],
          borderColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
            "#FF9F40",
            // Repeat colors if needed
          ],
          borderWidth: 1,
        },
      ],
    };

    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: 'Employee Task Quality Over Years',
        },
      },
    };

    return (
      <div>
        <Container>
          <Box
            sx={{
              backgroundColor: "#FF4D4D",
              padding: 2,
              borderRadius: 1,
              marginBottom: 2,
            }}
          >
            <Typography variant="h5" sx={{ color: "#fff" }}>
              Employee Task Chart
            </Typography>
          </Box>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Bar data={data} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default EmployeTaskChart;


